export type CVIconProps = {
    mainColor?: string;
    backColor?: string;
};

const CV_Icon = ({ mainColor = '#DBEBFF', backColor = 'rgb(2,65,255)' }: CVIconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="337.5 185.366 25 25" width="25pt" height="25pt">
        <g>
            <path
                fill={mainColor}
                d="M 344.5 186.37 L 356.5 186.37 C 359.811 186.37 362.5 189.059 362.5 192.37 L 362.5 204.37 C 362.5 207.681 359.811 210.37 356.5 210.37 L 344.5 210.37 C 341.189 210.37 338.5 207.681 338.5 204.37 L 338.5 192.37 C 338.5 189.059 341.189 186.37 344.5 186.37 Z"
            />
            <path
                fill={mainColor}
                d="M 344.5 186.37 L 356.5 186.37 C 359.811 186.37 362.5 189.059 362.5 192.37 L 362.5 204.37 C 362.5 207.681 359.811 210.37 356.5 210.37 L 344.5 210.37 C 341.189 210.37 338.5 207.681 338.5 204.37 L 338.5 192.37 C 338.5 189.059 341.189 186.37 344.5 186.37 Z"
            />
            <clipPath id="_clipPath_RURcOx3MOSXDihcwn1Mjmkh7uJzHdE7n">
                <rect x="343" y="190.866" width="14" height="14" transform="matrix(1,0,0,1,0,0)" fill={mainColor} />
            </clipPath>
            <g>
                <g>
                    <path
                        d=" M 355.5 192.366 L 355.5 203.366 L 344.5 203.366 L 344.5 192.366 L 355.5 192.366 Z  M 355.824 190.866 L 344.176 190.866 C 343.52 190.866 343 191.386 343 192.042 L 343 203.69 C 343 204.347 343.52 204.866 344.176 204.866 L 355.824 204.866 C 356.481 204.866 357 204.347 357 203.69 L 357 192.042 C 357 191.386 356.481 190.866 355.824 190.866 Z "
                        fill={backColor}
                    />
                    <path
                        d=" M 345.917 200.2 L 345.917 195.533 C 345.917 195.211 346.178 194.95 346.5 194.95 L 348.834 194.95 L 348.834 196.117 L 347.084 196.117 L 347.084 199.617 L 348.834 199.617 L 348.834 200.783 L 346.5 200.783 C 346.178 200.783 345.917 200.522 345.917 200.2 Z "
                        fill={backColor}
                    />
                    <path
                        d=" M 352.042 199.617 L 351.167 194.95 L 350 194.95 L 351.073 200.314 C 351.127 200.587 351.367 200.783 351.645 200.783 L 352.438 200.783 C 352.717 200.783 352.956 200.587 353.011 200.314 L 354.083 194.95 L 352.917 194.95 L 352.042 199.617 Z "
                        fill={backColor}
                    />
                </g>
            </g>
        </g>
    </svg>
);

export default CV_Icon;
